export enum EDITIONS {
  community = 'community',
  enterprise = 'enterprise',
}
